import * as React from 'react';

import RedeemCodeInput from './redeem-code-input';
import Button from 'components/button';
import Spinner from 'components/spinner/spinner.component';
import PageSupportBlockContainer from 'modules/page-support-block';
import { translate } from 'components/translate-hoc';

// constants
import {
    TEXT_KEYS,
    CODE_URL_PARAMETER
} from './redeem-code.constants';

// types
import { ITranslationProps } from 'types/translation';
import URLParams from 'utils/url-params';
import { IRedeemCodeFormat } from '@sitegen/common/types/redemption.types';

export class RedeemCodeForm extends React.Component<IRedeemCodeFormTranslateProps> {
    public componentDidMount(): void {
        const codeFromURL = this.getCodeFromURL();
        if (codeFromURL) {
            this.updateRedeemCode(codeFromURL);
        }
    }

    public updateRedeemCode = (code: string): void => {
        if (code) {
            const codeInUppercase = code.toUpperCase();
            this.props.updateCode({
                code: codeInUppercase,
                isValid: this.isCodeValid(codeInUppercase)
            });
        }
    };

    public getCodeFromURL(): string | null {
        return URLParams().get(CODE_URL_PARAMETER);
    }

    public isCodeValid = (code: string): boolean => {
        const lettersInBlock = this.props.codeFormat.characters;
        const testBlockLength = new RegExp(`[A-Z0-9]{${lettersInBlock}}`, 'g');

        if (code && code.length) {
            const amountOfBlocks = this.props.codeFormat.groups;
            const codeBlocks: string[] | null = code.match(testBlockLength);

            return codeBlocks ? codeBlocks.length === amountOfBlocks : false;
        } else {
            return false;
        }
    };

    public handleCodeSubmit = (): void => {
        this.props.submitCode();
    };

    public render() {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;

        const buttonText: string = translateKey(TEXT_KEYS.REDEEM_CODE_BUTTON_TEXT);

        return (
            <div className="sitegen-redeem-code">
                <RedeemCodeInput
                    code={this.props.code}
                    codeFormat={this.props.codeFormat}
                    onRedeemCodeChange={this.updateRedeemCode}
                />
                <PageSupportBlockContainer />
                <Button
                    loading={this.props.fetching}
                    onClick={this.handleCodeSubmit}
                >
                    {this.props.fetching && <Spinner/>}
                    {buttonText}
                </Button>
            </div>
        );
    }
}

export interface IRedeemCodeFormProps {
    readonly fetching: boolean;
    readonly code: string;
    readonly codeFormat: IRedeemCodeFormat;
    readonly updateCode: (params: { code: string, isValid: boolean }) => void;
    readonly submitCode: () => void;
}

export type IRedeemCodeFormTranslateProps = IRedeemCodeFormProps & ITranslationProps;

export default translate()(RedeemCodeForm) as React.ComponentClass<IRedeemCodeFormProps>;
